/**
 * Gluestack-UI Toast Portal pointer-events fix for web.
 *
 * React Native Web's pointerEvents="box-none" re-enables pointer-events on
 * children, so full-width toast wrapper divs block clicks. High-specificity
 * selectors disable pointer-events on wrapper layers while keeping toast content
 * interactive.
 */
export const TOAST_PORTAL_POINTER_EVENTS_CSS = `
  html body div[style*="position: fixed"]:has([id^="toast-"]),
  html body div[style*="position: fixed"]:has([id^="toast-"]) > div,
  html body div[style*="position: fixed"]:has([id^="toast-"]) > div > div,
  html body div[style*="position: fixed"]:has([id^="toast-"]) > div > div > div,
  html body div[style*="position: fixed"]:has([id^="toast-"]) > div > div > div > div {
    pointer-events: none !important;
  }

  html body [id^="toast-"],
  html body [id^="toast-"] * {
    pointer-events: auto !important;
  }
`;
